import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from '@storable/canaveral-components';
import get from 'lodash/get';
import AdminControls from '../containers/AdminControls';
import AdminHeaderPanel from './AdminHeaderPanel';

const { Header } = Layout;

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  controls: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  title: PropTypes.string,
  userAuthProfile: PropTypes.object.isRequired,
  corporateUrl: PropTypes.string.isRequired,
  storEdgeUrl: PropTypes.string.isRequired,
  hideViewLive: PropTypes.bool,
};

const defaultProps = {
  children: undefined,
  controls: undefined,
  title: undefined,
  hideViewLive: undefined,
};

class AdminHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = { showHeaderPanel: false };
  }

  onShowHeaderPanel = () => this.setState({
    showHeaderPanel: true,
  })

  onDismissHeaderPanel = () => this.setState({
    showHeaderPanel: false,
  })

  render() {
    const { showHeaderPanel } = this.state;
    const { children,
      controls,
      title,
      userAuthProfile,
      corporateUrl,
      storEdgeUrl,
      hideViewLive } = this.props;
    const { facilityLevelLinkText } = get(userAuthProfile, 'globalNavigation', {});
    const headerPanel = (
      userAuthProfile.hasGlobalNavigationAccess &&
        <AdminHeaderPanel
          show={showHeaderPanel}
          onDismiss={this.onDismissHeaderPanel}
          facilityLevelLinkText={facilityLevelLinkText}
          userAuthProfile={userAuthProfile}
          corporateUrl={corporateUrl}
          storEdgeUrl={storEdgeUrl}
        />
    );

    const headerLogo = (
      <Header.Logo
        onClick={userAuthProfile.hasGlobalNavigationAccess ? this.onShowHeaderPanel : undefined}
      />
    );

    return (
      <Layout.Header logo={headerLogo} panel={headerPanel}>
        <Header.Text bordered={!!children}>
          {title}
        </Header.Text>
        {children}
        <AdminControls hideViewLiveButton={hideViewLive}>
          {controls}
        </AdminControls>
      </Layout.Header>
    );
  }
}

AdminHeader.propTypes = propTypes;
AdminHeader.defaultProps = defaultProps;

export default AdminHeader;
